import React = require('react');
import { IChannel, ITraveller } from '../../../../../../../../data/api/models';
import { get, isEmpty, map, startCase } from 'lodash';
import { Col, Row } from 'react-bootstrap';
import { TITLES } from '../../../../../../../../helpers/Quote';
import { Field, InjectedFormProps } from 'redux-form';
import FieldFormControl from '../../../../../../../../components/FieldFormControl';
import {
  allowOnlyApostrophes,
  hasEmojis,
  hasSpecialCharacters,
  isEmail,
  isPhone,
  isRequired
} from '../../../../../../../../util/validators';
import { PostcodeLookup } from '../../../../../Components/PostcodeLookup';
import QuoteIcons from '../../../../../Components/Icon/QuoteIcons';
import { ErrorDisplay } from '../../../../../../../../components/FieldFormControl/ErrorDisplay';

interface IAggTravellersEditProps extends InjectedFormProps {
  travellers: ITraveller[];
  channel: IChannel;
  synchronousError: any;
}

export const AggTravellersEdit = ({ travellers, change, synchronousError, channel, ...props }: IAggTravellersEditProps) => {

  if (isEmpty(travellers)) {
    return null;
  }

  let adult = 0;
  let child = 0;

  return (
    <div>
      {map(travellers, (traveller, index) => {
        const selectedTitle = get(traveller, 'title')
        const travellerType = get(traveller, 'type')
        const titleError = get(synchronousError, `travellers[${index}].title`, null);

        if (travellerType === 'adult') {
          adult++
        }

        if (travellerType === 'child') {
          child++
        }

        return (
          <div key={index} className={'travellers-container'}>
            <Row>
              {index > 0 && (
                <Col xs={12} className={'full-width-xs travellers-type'}>
                  <div>
                    <QuoteIcons name={'Person'} color={'blue'}/>
                  </div>
                  <div>
                    {startCase(travellerType) + (travellerType === 'adult' ? adult : child)}
                  </div>
                </Col>
              )}
              <Col xs={6} className={'full-width-xs'}>Your preferred title</Col>
              <Col xs={6} className={'full-width-xs title-selection-container'}>
                {map(TITLES, (value, key) => {
                  const isSelected = selectedTitle === value;
                  return (
                    <Col xs={4}
                         className={isSelected ? 'traveller-title-selection selected' : (titleError ? 'traveller-title-selection has-error' : 'traveller-title-selection')}>
                      <div>
                        <Field
                          name={`travellers[${index}].title`}
                          id={key + '-btn'}
                          type="radio"
                          value={value}
                          component={FieldFormControl}
                          validationMessage={'single'}
                          validate={[isRequired]}
                        >
                          <div className={`trip-type-btn ${key}`}>
                            <div className={'trip-type-selection-container'}>
                              {value}
                            </div>
                          </div>
                        </Field>
                      </div>
                    </Col>
                  )
                })}
              </Col>
              {titleError && (
                <>
                  <Col xs={6}/>
                  <Col xs={6} className={'full-width-xs'}>
                    <ErrorDisplay error={titleError}/>
                  </Col>
                </>
              )}
            </Row>
            <Row className={'adm-form-group'}>
              <Col xs={6} className={'full-width-xs'}>First Name</Col>
              <Col xs={6} className={'full-width-xs'}>
                <Field
                  name={`travellers[${index}].firstName`}
                  type="text"
                  component={FieldFormControl}
                  validate={[isRequired, hasEmojis, hasSpecialCharacters]}
                  autocomplete="new-password"
                />
              </Col>
            </Row>
            <Row className={'adm-form-group'}>
              <Col xs={6} className={'full-width-xs'}>Last Name</Col>
              <Col xs={6} className={'full-width-xs'}>
                <Field
                  name={`travellers[${index}].lastName`}
                  type="text"
                  component={FieldFormControl}
                  validate={[isRequired, hasEmojis, allowOnlyApostrophes]}
                  autocomplete="new-password"
                />
              </Col>
            </Row>
            <Row className={'adm-form-group'}>
              <Col xs={6} className={'full-width-xs'}>Date of Birth</Col>
              <Col xs={2} className={'full-width-xs'}>
                <Field
                  name={`travellers[${index}].dobSeparate.day`}
                  inputmode="numeric"
                  type="text"
                  maxLength={'2'}
                  className={'text-center'}
                  component={FieldFormControl}
                  validate={[isRequired, hasEmojis]}
                  autocomplete="new-password"
                />
                <div className={'text-center'}>Day</div>
              </Col>
              <Col xs={2} className={'full-width-xs'}>
                <Field
                  name={`travellers[${index}].dobSeparate.month`}
                  inputmode="numeric"
                  type="text"
                  maxLength={'2'}
                  className={'text-center'}
                  component={FieldFormControl}
                  validate={[isRequired, hasEmojis]}
                  autocomplete="new-password"
                />
                <div className={'text-center'}>Month</div>
              </Col>
              <Col xs={2} className={'full-width-xs'}>
                <Field
                  name={`travellers[${index}].dobSeparate.year`}
                  inputmode="numeric"
                  type="text"
                  maxLength={'4'}
                  className={'text-center'}
                  component={FieldFormControl}
                  validate={[isRequired, hasEmojis]}
                  autocomplete="new-password"
                />
                <div className={'text-center'}>Year</div>
              </Col>
            </Row>
            {index === 0 && (
              <>
                <Row className={'adm-form-group'}>
                  <Col xs={6} className={'full-width-xs'}>Email address</Col>
                  <Col xs={6} className={'full-width-xs'}>
                    <Field
                      name={`travellers[${index}].email`}
                      type="email"
                      component={FieldFormControl}
                      validate={[isRequired, isEmail]}
                      autocomplete="new-password"
                    />
                  </Col>
                </Row>
                <Row className={'adm-form-group'}>
                  <Col xs={6} className={'full-width-xs'}>Phone number</Col>
                  <Col xs={6} className={'full-width-xs'}>
                    <Field
                      name={`travellers[${index}].phone`}
                      inputmode="numeric"
                      type="text"
                      component={FieldFormControl}
                      validate={[isRequired, isPhone]}
                      autocomplete="new-password"
                    />
                  </Col>
                </Row>
                <PostcodeLookup change={change}
                                basePath={'travellers[0].address'}
                                travellers={travellers}
                                title={'Home address'}
                                channel={channel}
                                {...props}/>
              </>
            )}
          </div>
        )
      })}
    </div>
  )
}
